import React from "react";
import UserManagementComponent from "../../components/UserManagementComponent";

const UserManagementScreen = () => {
  return <UserManagementComponent />;
};

export default UserManagementScreen;
